import React from "react";
import { createRoot } from "react-dom/client";

import FleetLocalizationProvider from "@carrier-io/air-react/FleetLocalizationProvider";
import FleetThemeProvider from "@carrier-io/air-react/theme/FleetThemeProvider";
import { StyledEngineProvider } from "@carrier-io/air-react/styles";
import { App } from "./app";

const node = document.getElementById("root");
if (!node) {
  throw new Error("Root element not found");
}
const root = createRoot(node);

root.render(
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <FleetLocalizationProvider>
    <StyledEngineProvider injectFirst>
      <FleetThemeProvider>
        <App />
      </FleetThemeProvider>
    </StyledEngineProvider>
  </FleetLocalizationProvider>,
);

// vim:expandtab:sw=2:ts=2
